<template>
  <div>
    <p class="headline" v-html="$t('tutorial.stepStartAutoavaluation.TITLE')"></p>
    <p class="subheading" style="text-align: justify" v-html="$t('tutorial.stepStartAutoavaluation.BODY')"></p>
    <v-layout row wrap>
      <v-flex xs12>
        <v-toolbar dark color="primary">
          <v-toolbar-side-icon v-on:click=""><v-icon>home</v-icon></v-toolbar-side-icon>
          <v-toolbar-title style="cursor: pointer;" class="white--text" v-on:click="">{{ $t('navbar.TITLE') }}</v-toolbar-title>
          <v-spacer></v-spacer>
          {{ $route.currentRoute }}
          <v-btn round flat v-on:click="">
            <div class="hidden-xs-only">{{ this.$auth.user().username }}</div>
            <v-icon right>person</v-icon>
          </v-btn>
          <v-btn icon @click.native.stop="">
            <v-icon>exit_to_app</v-icon>
          </v-btn>
        </v-toolbar>
      </v-flex>
      <v-flex xs10 offset-xs1>
        <v-data-table
          v-bind:headers="headersTeacher"
          :rows-per-page-text="$t('results.table.ROWSPERPAGE')"
          :items="questionnaires"
          class="elevation-1">
          <template slot="items" slot-scope="props">
            <td>{{props.item.creationDate | formatDate}}</td>
            <td>{{props.item.level ? levels[props.item.level] : '-'}}</td>
            <td>{{props.item.group ? groups[props.item.group] : '-'}}</td>
            <td>{{props.item.subject ? props.item.subject : '-'}}</td>
            <td>{{props.item.activityDescription}}</td>
            <td>
              <v-tooltip top>
                <v-btn class="blinking" flat icon v-on:click="$emit('continue')" slot="activator">
                  <v-icon>forward</v-icon>
                </v-btn>
                <span>{{ $t('questionnaires.tooltips.ANSWER') }}</span>
              </v-tooltip>
            </td>
          </template>
        </v-data-table>
      </v-flex>
    </v-layout>
    <v-spacer></v-spacer>
    <v-container>
      <v-layout>
        <v-btn @click.native="$emit('back')" flat>{{ $t('tutorial.buttons.BACK') }}</v-btn>
        <v-spacer></v-spacer>
      </v-layout>
    </v-container>
  </div>
</template>

<script>
import {GROUPS, LEVELS} from '../../api/utils'

export default {
  name: 'TutorialQuestionnairesList',
  data () {
    const generateDict = function (arr) {
      var res = {}
      arr.forEach(function (item) {
        res[item.value] = item.text
      })
      return res
    }
    return {
      headersTeacher: [
        { text: this.$t('questionnaires.headers.DATE'), value: 'creationDate' },
        { text: this.$t('questionnaires.headers.LEVEL'), align: 'left', value: 'level' },
        { text: this.$t('questionnaires.headers.GROUP'), align: 'left', value: 'group' },
        { text: this.$t('questionnaires.headers.SUBJECT'), align: 'left', value: 'subject' },
        { text: this.$t('questionnaires.headers.ACTIVITY'), align: 'left', value: 'activityDescription' }
      ],
      questionnaires: [
        {id: 1, creationDate: '21/01/2021', level: 1, group: 1, subject: this.$t('tutorial.stepStartAutoavaluation.SUBJECT'), activityDescription: this.$t('tutorial.stepStartAutoavaluation.DESCRIPTION')}
      ],
      levels: generateDict(LEVELS),
      groups: generateDict(GROUPS)
    }
  }
}
</script>

<style scoped>
  .blinking {
    border: 3px solid #4caf50;
    animation: blink 1.3s ease-in infinite;
  }

  .blinking:hover {
    animation: none;
  }

  .btn__content {
    height: fit-content;
  }

  @keyframes blink {
    from, to { opacity: 1 }
    50% { opacity: 0.1 }
  }

</style>



// WEBPACK FOOTER //
// src/components/tutorial/TutorialQuestionnairesList.vue